
<label class="switch switch-icon switch-pill switch-primary m-t-04">
  <input [checked]="isChecked === true || isChecked === trueValue" [disabled]="isDisable" (change)="toggleSwitch($event)" type="checkbox" class="switch-input">
  <span class="switch-label" [attr.data-on]="onIcon" [attr.data-off]="offIcon"></span>
  <span class="switch-handle"></span>
</label>
